/**
 * True when `expiresAt` is within `skewSeconds` of now — i.e. the credential
 * should be renewed before it is used again.
 *
 * A credential with no expiry is never considered expiring: sources that cannot
 * express expiry (some host handovers) must not be renewed on a guess.
 *
 * Plain epoch arithmetic, deliberately not in `jwt.helpers`: it decodes nothing
 * and applies equally to a credential whose expiry never came from a JWT.
 */
export function isExpiring(
  expiresAt: number | undefined,
  nowMs: number,
  skewSeconds: number,
): boolean {
  if (expiresAt === undefined) return false;
  return expiresAt * 1000 - skewSeconds * 1000 <= nowMs;
}
